import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import alarm from './modules/alarm'
import drawer from './modules/drawer'
import issues from './modules/issues'
import search from './modules/search'
import statistics from './modules/statistics'
import realEstate from './modules/real_estate'
import blocks from './modules/blocks'
import status from './modules/status'
import greenview from './modules/greenview'
import alarmHistory from './modules/alarmHistory'
import globalInfo from './modules/globalInfo'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  modules: {
    account,
    alarm,
    drawer,
    issues,
    search,
    statistics,
    realEstate,
    blocks,
    status,
    greenview,
    alarmHistory,
    globalInfo
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js